// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip-content {\n    background: #001E38;\n    color: #fff;\n}\n.tooltip-text::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: #001E38 transparent transparent transparent;\n}\n.disabled-icon {\n  opacity: 0.5 !important;\n  pointer-events: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
